import { Box, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Our_Team, Our_Team_second_content } from "../../Utils/Constants";
import OurTeamBanner from "../../assets/img/images/Our-Team-Banner.jpg";
import OurTeamMembers from "./OurTeamMembers/OurTeamMembers";
import { useNavigate } from "react-router-dom";
import { Path } from "../../Utils/ScreenPath";
import { GetPageContent } from "../../services/websitePageSection";
import { useEffect, useState } from "react";
import WithSkeleton from "../Common/WithSkeleton";

const Process_Card = ({
  item,
  findSectionBySectionId,
  titleSectionId,
  decSectionId,
}) => {
  return (
    <Box className="Process_Card_Box">
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box className="Process_Card_Title">
          {findSectionBySectionId({
            sectionId: titleSectionId,
            String: item.title,
          })}
        </Box>
        {item.index ? (
          <Box className="Process_Card_Index">
            <img src={item.index} alt="" />
          </Box>
        ) : null}
      </Box>
      <Box className="Process_Card_Sub_Title">
        {findSectionBySectionId({
          sectionId: decSectionId,
          String: item.subTitle,
        })}
      </Box>
    </Box>
  );
};

const OurTeamComponent = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [pageContent, setPageContent] = useState([]);
  const [pageContentLoading, setPageContentLoading] = useState(false);

  console.log("pageContent", pageContent);

  const handelGetPageContent = () => {
    setPageContentLoading(true);
    GetPageContent(Path.OurTeam)
      .then((res) => {
        const content = res?.data;
        setPageContent(content || []);
        setPageContentLoading(false);
      })
      .catch((err) => setPageContentLoading(false));
  };

  const findSectionBySectionId = ({
    sectionId,
    String,
    isLink = false,
    corssCheck = false,
    corssCheckId = null,
  }) => {
    if (!corssCheck) {
      return String;
    } else if (corssCheckId) {
      const object = pageContent?.find(
        (item) => item?.SectionId === corssCheckId
      );

      if (!object?.SectionText) {
        return String;
      } else {
        return null;
      }
    } else {
      const object = pageContent?.find((item) => item?.SectionId === sectionId);

      if (!object?.SectionText) return String;

      // if isLink → return plain text (strip all HTML tags)
      if (isLink) {
        return object?.SectionText.replace(/<[^>]+>/g, "");
      }

      // otherwise → render HTML safely
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: object?.SectionText,
          }}
          className="findSectionBySectionId"
        />
      );
    }
  };

  useEffect(() => {
    handelGetPageContent();
  }, []);

  return (
    <>
      <Box
        style={{
          // background: `url(${OurTeamBanner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${OurTeamBanner}) center/cover no-repeat`,
        }}
        className="bg-[image:var(--image-url)]"
      >
        <Box className="container">
          <Box className="Our_Team_Banner_Title">
            {findSectionBySectionId({
              sectionId: 1,
              String: "Meet Our Team",
            })}
          </Box>
        </Box>
      </Box>

      <Box
        className="Our_Team_Banner_Sub_Box"
        sx={{
          paddingY: {
            xs: "40px", // For extra small screens (mobile)
            sm: "60px", // For small screens (tablets)
            md: "80px", // For medium screens (laptops)
            lg: "100px", // For large screens (desktops)
          },
        }}
      >
        <Box className="container">
          <Box className="Our_Team_Banner_Sub_Title">
            {findSectionBySectionId({
              sectionId: 2,
              String:
                "At Marcel Equipment Limited, our team is dedicated to your success and committed to providing exceptional service in every aspect of your equipment needs. With decades of experience in the construction and landfill industries, our professionals are here to ensure you receive the best solutions tailored to your projects.",
            })}
          </Box>

          <Box className="Expertise_Text">
            {findSectionBySectionId({
              sectionId: 3,
              String: "Our Expertise Includes:",
            })}
          </Box>

          <Grid container item spacing={4} sx={{ marginBottom: "20px" }}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Process_Card
                item={Our_Team.Sales_Rentals}
                findSectionBySectionId={findSectionBySectionId}
                titleSectionId={4}
                decSectionId={5}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Process_Card
                item={Our_Team.Technical_Support}
                findSectionBySectionId={findSectionBySectionId}
                titleSectionId={6}
                decSectionId={7}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Process_Card
                item={Our_Team.Customer_Service}
                findSectionBySectionId={findSectionBySectionId}
                titleSectionId={8}
                decSectionId={9}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      <OurTeamMembers findSectionBySectionId={findSectionBySectionId} />

      <Box sx={{ background: "#ffffff" }}>
        <Box
          className="container"
          sx={{
            paddingY: {
              xs: "40px", // For extra small screens (mobile)
              sm: "60px", // For small screens (tablets)
              md: "80px", // For medium screens (laptops)
              lg: "100px", // For large screens (desktops)
            },
            maxWidth: "950px",
          }}
          margin={"auto"}
        >
          <Box className="explore_title" textAlign={"center"}>
            {findSectionBySectionId({
              sectionId: 68,
              String:
                "Together, we can achieve your project goals with the right equipment and support.",
            })}
          </Box>
          <Box
            marginTop={"20px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexWrap={"wrap"}
          >
            <Button
              className="our_team"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path?.Category);
              }}
            >
              <span style={{ minWidth: "150px" }}>
                {findSectionBySectionId({
                  sectionId: 69,
                  String: "Explore Our Inventory",
                })}
                {/* Explore Our Inventory */}
              </span>
            </Button>
            <Button
              className="about_us"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path.AboutUs);
              }}
            >
              <span style={{ width: "150px" }}>
                {findSectionBySectionId({
                  sectionId: 70,
                  String: "ABOUT US",
                })}
              </span>
            </Button>
            <Button
              className="contact_us"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path.ContactUs);
              }}
              style={{ cursor: "pointer" }}
            >
              <span style={{ width: "150px" }}>
                {findSectionBySectionId({
                  sectionId: 71,
                  String: "CONTACT US",
                })}
              </span>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default OurTeamComponent;
